import axios from "axios";

const apiUrl = process.env.REACT_APP_VISBOOK_ENDPOINT + "/api/";
const entity = process.env.REACT_APP_VISBOOK_ENTITY;
const frontendBaseUrl = process.env.REACT_APP_FRONTEND_BASE_URL;

const dateFormat = (date) => {
  return (
    date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
  );
};

const visbook = {
  webproducts: async ({ fromDate, toDate, numRooms, numPersons }) => {
    fromDate = new Date(fromDate);
    toDate = new Date(toDate);

    return new Promise((resolve, reject) => {
      axios
        .get(
          `${apiUrl}${entity}/webproducts/${dateFormat(fromDate)}/${dateFormat(
            toDate
          )}`,
          {
            params: {
              numberOfPersons: numPersons,
            },
          }
        )
        .then((response) => {
          let availableHotels = response.data.accommodations.map((hotel) => {
            hotel.available =
              hotel.availability.available &&
              hotel.availability.steps.every((step) => {
                return step.availableUnits >= numRooms;
              });

            return hotel;
          });
          resolve(availableHotels);
        })
        .catch((e) => {
          reject(new Error(e));
        });
    });
  },
  webproductsById: () => {
    return axios.get(`${apiUrl}${entity}/webproducts/`);
  },
  reserveRoom: ({
    webProductId,
    fromDate,
    toDate,
    priceId,
    numberOfPeople,
  }) => {
    return axios.post(`${apiUrl}${entity}/reservations`, {
      webProductId,
      fromDate: fromDate,
      toDate: toDate,
      priceId,
      numberOfPeople,
    });
  },
  pingReservations: (reservations) => {
    return axios.post(`${apiUrl}${entity}/reservations/ping`, reservations);
  },
  startEmailValidation: async (email) => {
    let formData = new FormData();
    formData.set("email", email);

    return axios.post(`${apiUrl}${entity}/login/request/email`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  confirmEmailToken: async (token) => {
    return axios.get(`${apiUrl}${entity}/validation/email/${token}`, {
      withCredentials: true,
    });
  },
  getCurrentUser: () => {
    return axios.get(`${apiUrl}${entity}/user/`);
  },
  checkout: async ({ reservations, amount, customer, acceptedTerms }) => {
    axios
      .post(
        `${apiUrl}${entity}/checkout/userinfo`,
        reservations.map((r) => {
          return {
            reservationId: r.reservationId,
            encryptedCompanyId: r.encryptedCompanyId,
          };
        })
      )
      .then((r) => {
        console.log(r);
      });

    return axios.post(
      `${apiUrl}${entity}/checkout`,
      {
        reservations,
        successUrl: `${frontendBaseUrl}/checkout/success`,
        errorUrl: `${frontendBaseUrl}/checkout/failed`,
        paymentType: "netAxept",
        amount,
        customer,
        acceptedTerms,
      },
      {
        withCredentials: true,
      }
    );
  },
  loadOrderGroupData: async (orderGroupId) => {
    return axios.get(`${apiUrl}${entity}/ordergroups/${orderGroupId}`, {
      withCredentials: true,
    });
  },
};

export default visbook;
